export class JQueryTools {
    public static Exists = (obj?: JQuery): boolean => {
        return (obj != null || obj.length > 0);
    }
}